import './styled.scss';
import { useRef, useEffect, useState } from 'react';

import { contentSection, dataSlide, titleSection, ILocation } from 'data/location';
import { GetMobileStyledCompImg } from 'common-modules/general/Modules/functions';
import { GetGeocode } from 'common-modules/general/Modules/functions';

import pinMain from 'assets/common/ico_pin03.png';
import pinSub from 'assets/common/ico_pin05.png';
import { Swiper, SwiperSlide } from 'swiper/react';

import developmentPlan01 from 'assets/Desktop/images/parcelOut/dev01.jpg';
import developmentPlan02 from 'assets/Desktop/images/parcelOut/dev02.jpg';
import developmentPlan03 from 'assets/Desktop/images/parcelOut/dev03.jpg';

const Event = () => {
  // pop-up initial
  const popUp = useRef<any>(null);
  const popUpImg = useRef<any>(null);

  const openPopUp = (popUpName, img?: any) => {
    popUpName.current.style.visibility = 'visible';
    popUpName.current.style.opacity = 1;
    const body = document.body;

    body.style.overflow = 'hidden';

    if (img) {
      popUpImg.current.setAttribute('src', img);
    }
  };
  const closePopUp = popUpName => {
    popUpName.current.style.visibility = 'hidden';
    popUpName.current.style.opacity = 0;
    const body = document.body;

    body.style.overflow = 'unset';
  };

  const [selectedAddress, setSelectedAddress] = useState<ILocation>({
    img: '',
    title: '현장',
    address: '충청북도 옥천군 옥천읍 동안리 15-1번지'
  });

  const handleClickMap = (sp: ILocation) => {
    setSelectedAddress(sp);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        // #1. 네이버맵을 위한 좌표 변환
        const address_1: string = selectedAddress.address;
        const item: naver.maps.Service.AddressItemV2 = await GetGeocode(address_1);
        const fixItem: naver.maps.Service.AddressItemV2 = await GetGeocode('충청북도 옥천군 옥천읍 동안리 15-1번지');
        // 네이버맵 가동 (현장위치)
        const location_1_map: naver.maps.Map = new naver.maps.Map('location_1', {
          center: new naver.maps.LatLng(Number(item.y), Number(item.x)),
          zoom: 17, // 지도의 초기 줌 레벨
          minZoom: 13, // 지도의 최소 줌 레벨
          maxZoom: 18, // 지도의 최대 줌 레벨
          zoomControl: true, // 줌 컨트롤의 표시 여부
          mapTypeControl: true
        });

        // 네이버맵 보조 마커 표시 (현장위치)
        const promises: Promise<void>[] = dataSlide.map((value: any) => {
          return new Promise<void>(async resolve => {
            try {
              const _i: naver.maps.Service.AddressItemV2 = await GetGeocode(value.address);

              if (value.address !== selectedAddress.address) {
                new naver.maps.Marker({
                  title: value.title,
                  position: new naver.maps.LatLng(Number(_i.y), Number(_i.x)),
                  map: location_1_map,
                  icon: pinSub
                });
              }
              resolve();
            } catch {
              resolve();
            }
          });
        });

        await Promise.all(promises);

        if (selectedAddress.title !== '현장') {
          // 네이버맵 마커 표시 (현장위치)
          new naver.maps.Marker({
            position: new naver.maps.LatLng(Number(item.y), Number(item.x)),
            map: location_1_map,
            icon: {
              content: `     <div class='pin'>
        <span class='pin-container'>
          <span class='pin-img'><img src=${pinMain} alt=${selectedAddress.title} /></span>
          <span class='pin-title' >${selectedAddress.title}</span>
        </span>
      </div>
        `
            }
          });
        }

        new naver.maps.Marker({
          position: new naver.maps.LatLng(Number(fixItem.y), Number(fixItem.x)),
          map: location_1_map,
          icon: {
            content: `     <div class='pin'>
              <span class='pin-container'>
                <span class='pin-point' style="z-index: 1;"></span>
                <span class='pin-title' style="z-index: 1;">현장</span>
              </span>
            </div>
              `,
            size: new naver.maps.Size(38, 58)
          }
        });
      } catch (e) {}
    };

    fetchData();
  }, [selectedAddress]);

  // 220830 add
  interface contentList {
    name: string;
    isActive: boolean;
  }

  const contentList = [
    { name: '특징', isActive: true},
    { name: '주변시설', isActive: true},
    { name: '개발 계획', isActive: true}
  ];

  return (
    <div className="contents-location-mobile">
      {/* 특징  */}
      {contentList[0].isActive ? (
        <div id="infoMap" className="infoMap">
          <div className="infoMap-icon">
            <div className="icon"></div>
          </div>
          <div className="infoMap-title">{titleSection.tit}</div>
          {/* <div className="infoMap-detail mt-10">{titleSection.desc}</div> */}
          <div className="infoMap-img">
            <img
              onClick={() => {
                openPopUp(popUp, titleSection.PositionImgBig);
              }}
              src={titleSection.PositionImg}
              alt=""
            />
          </div>
          {/* <div className="slideLocation-notice">
            <p>{titleSection.infoMap}</p>
          </div> */}
          <div className="noti-text">
            <p className="desc dash indent">{titleSection.infoMap}</p>
            <p className="desc dash indent">{titleSection.infoMap2}</p>
          </div>

          {/* 홍보문구 */}
          <div className="infoMap-content">
            {contentSection.map((value, idx) => {
              return (
                <div className="infoMap-content-items" key={idx}>
                  <div className="title">{value.tit}</div>
                  <ul className="list-items">
                    {value.desc.map((val, innerIdx) => (
                      <li key={innerIdx}>{val}</li>
                    ))}
                  </ul>
                </div>
              );
            })}
          </div>

          {/* <div className="infoMap-img">
            <img
              onClick={() => {
                openPopUp(popUp, titleSection.wideBirdsView);
              }}
              src={titleSection.wideBirdsView}
              alt=""
            />
          </div> */}
        </div>
      ) : null}

      {/* 주변시설 */}
      {contentList[1].isActive ? (
        <div id="sliceLocation" className="slideLocation">
          <div className="slideLocation-title">주변시설</div>
          <div className="slideLocation-subTitle">최고의 입지</div>
          <div className="slideLocation-detail">교통, 병원, 생활 편의 시설까지 완벽한 입지를 누린다.</div>
          <div className="slideLocation-img">
            <div id="location_1" style={{ width: '100%', height: '100%' }}></div>
          </div>
          <Swiper className="layout-slide" preventClicks={false} navigation={false} slidesPerView={1.6} spaceBetween={20}>
            <div className="layout-slide-wrapper">
              {dataSlide.map((item, index) => {
                return (
                  <SwiperSlide key={index} className="layout-slide-item">
                    <div className="main-items-content layout-slide-item-title">{item.title}</div>

                    <img onClick={() => handleClickMap(item)} className="layout-slide-item-img" src={item.img} alt="" />
                  </SwiperSlide>
                );
              })}
            </div>
          </Swiper>

          <div className="slideLocation-notice">* 본 사진은 2022년 09월에 촬영된 사진입니다.</div>
        </div>
      ) : null}

      {/* 개발 계획 */}
      {contentList[2].isActive ? (
        <div id="infoHouse" className="infoHouse">
          <div className="infoHouse-title">개발계획</div>
          <div>
          <div className="infoHouse-subTitle">대전-옥천 광역철도</div>
            <div className="infoHouse-content">
              <div className="infoHouse-content-left">
                <div className="content-detail">
                  <div className="content-detail-items">
                    <span className="title">사업구간</span>
                    <span className="detail">오정 ~ 옥천 /. 20.1km</span>
                  </div>
                  <div className="content-detail-items">
                    <span className="title">사업기간</span>
                    <span className="detail">2021년 ~ 2026년</span>
                  </div>
                  <div className="content-detail-items">
                    <span className="title">총사업비</span>
                    <span className="detail">490억원</span>
                  </div>
                  <div className="content-detail-items">
                    <span className="title">사업내용</span>
                    <span className="detail">정거장 4개소(오정,대전,세천,옥천), 기존선 활용</span>
                  </div>
                  <div className="content-detail-items">
                    <div className='content-detail-items__list'>
                      <h3>추진사항</h3>
                      <ul className='desc'>
                        <li>제3차 국가철도망구축계획고시(’16.12.)</li>
                        <li>사전타당성조사(’16.12.)</li>
                        <li>기본계획용역 착수(‘20.2.)</li>
                        <li>기본계획용역 준공(‘20.12.)</li>
                        <li>제4차 국가철도망 구축계획 고시(’21.7.)</li>
                        <li>기본계획고시(’21.10.)</li>
                        <li>기본 및 실시설계 착수(22.4.)</li>
                      </ul>
                    </div>

                    <div className='content-detail-items__list'>
                      <h3>향후 추진방향</h3>
                      <ul className='desc'>
                        <li>기본 및 실시설계 완료(‘23.8.)</li>
                        <li>공사착공 예정(‘24.4)</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="infoHouse-content-right">
                <img
                  onClick={() => {
                    openPopUp(popUp, developmentPlan03);
                  }}
                  src={developmentPlan03}
                  alt=""
                />
              </div>
            </div>
          </div>

          <div className="infoHouse-notice">
            <p>* 참고자료 : 옥천군청 홈페이지<br />(https://www.daejeon.go.kr/djTram/contentView.do?menuSeq=6721)</p>
            <p>* 상기개발계획은 사업주체, 국가기관, 지자체 및 기타기관의 사업추진 중 변경, 지연, 취소될 수 있습니다.</p>
          </div>
        </div>
      ) : null}

      <div ref={popUp} className="pop-up">
        <div>
          <div className="pop-up-header">
            <img
              onClick={() => {
                closePopUp(popUp);
              }}
              className="btn-close"
              src={GetMobileStyledCompImg('common/ico_close02.png')}
              alt="icoClose02"
            />
          </div>
          <div className="pop-up-img">
            <img ref={popUpImg} src="" alt="DL건설" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Event;
